import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9" }) => (
  <img src="/logo-purple.png" alt="خرابيش موشن" width="1099" height="592" className={`w-auto ${className}`} />
);

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="brand-logo-link" aria-label="خرابيش موشن - الرئيسية" className={`group flex items-center gap-3 ${className}`}>
    <span className="rounded-2xl bg-white px-3 py-1.5 shadow-[0_0_24px_rgba(125,44,198,0.55)] transition-transform duration-300 group-hover:-rotate-6">
      <LogoMark className="h-9 sm:h-10" />
    </span>
    <span className="font-head hidden text-xs font-semibold text-[var(--km-lilac)] sm:block">خربش على السوق</span>
  </Link>
);
